import UserAvatarIcon from './component'

export default UserAvatarIcon
